import { t } from "@lingui/macro";
import { useNavigation } from "@react-navigation/native";
import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { Button } from "@whoosh/design-system/src/components/controls";
import { ArrowLeftIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import {
  Box,
  HStack,
  Text,
  VStack,
} from "@whoosh/design-system/src/components/primitive";

import { ClubLogo } from "../../../components/ClubLogo/ClubLogo";
import { EventDetailRedesignedHeader$key } from "./__generated__/EventDetailRedesignedHeader.graphql";

type EventDetailRedesignedHeaderProps = {
  fragmentRef: EventDetailRedesignedHeader$key;
};

export const EventDetailRedesignedHeader = ({
  fragmentRef,
}: EventDetailRedesignedHeaderProps) => {
  const data = useFragment(EventDetailRedesignedHeaderFragment, fragmentRef);
  const navigation = useNavigation();

  const club = data.eventSeries.facility?.club ?? null;
  const clubName = club?.name;

  return (
    <HStack
      justifyContent="space-between"
      alignItems="center"
      paddingHorizontal={{ base: 4, md: 0 }}
      paddingVertical={3}
      gap={4}
      testID="event-detail-redesigned-header"
    >
      <Box width={56} height={56}>
        <Button
          variant="secondary"
          onPress={() => navigation.goBack()}
          leftIcon={<ArrowLeftIcon />}
          accessibilityLabel={t`Back button`}
          testID="event-detail-back-button"
        />
      </Box>

      <VStack flex={1} alignItems="center" justifyContent="center">
        {clubName ? (
          <Text
            variant="mainTiny"
            color="text-secondary"
            textAlign="center"
            numberOfLines={1}
          >
            {clubName}
          </Text>
        ) : null}
        <Text
          variant="mainBaseSemiBold"
          color="text-primary"
          textAlign="center"
        >
          {t`Event Detail`}
        </Text>
      </VStack>

      <Box width={56} height={56}>
        <ClubLogo clubRef={club ?? null} />
      </Box>
    </HStack>
  );
};

export const EventDetailRedesignedHeaderFragment = graphql`
  fragment EventDetailRedesignedHeader on Event {
    eventSeries {
      facility {
        club {
          name
          ...ClubLogo_Club
        }
      }
    }
  }
`;
